import { ReactComponent as HomeIcon } from '../../../Asset/sidenavIcons/home.svg'
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';
import { Analytics } from '@mui/icons-material';
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import ScheduleOutlinedIcon from '@mui/icons-material/ScheduleOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ContactSupportOutlinedIcon from '@mui/icons-material/ContactSupportOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import routes from '../../../Utils/routes';
import { useStyles } from '../styles';
import { ListItemButton, ListItemIcon, ListItemText, useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';

interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
}

const SideNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const getFirstPath = pathname.split('/').filter((items: string) => {
    return items && items !== '';
  });

  const is1980 = useMediaQuery('(max-width:1280px)');

  const sideNavContents = [
    {
      icon: (isActive: boolean) => {
        return <HomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    {
      icon: (isActive: boolean) => {
        return <AccountCircleIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'My Profile',
      link: routes.myProfile,
      name: 'myProfile',
    },
    {
      icon: (isActive: boolean) => {
        return <ImportContactsIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Plan My Program',
      link: routes.PlanMyProgram,
      name: 'planmyprogram',
    },
    {
      icon: (isActive: boolean) => {
        return <Analytics className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Academics',
      link: routes.academics,
      name: 'academics',
    },
    {
      icon: (isActive: boolean) => {
        return <PeopleOutlineOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'My Students',
      link: routes.myStudents,
      name: 'myStudents',
    },
    {
      icon: (isActive: boolean) => {
        return <CalendarTodayOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Attendance',
      link: routes.attendance,
      name: 'attendance',
    },
    {
      icon: (isActive: boolean) => {
        return <ScheduleOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'My Schedule',
      link: routes.mySchedule,
      name: 'mySchedule',
    },
    {
      icon: (isActive: boolean) => {
        return <AutoAwesomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Events',
      link: routes.events,
      name: 'events',
    },
    {
      icon: (isActive: boolean) => {
        return <ContactSupportOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Service & Support',
      link: routes.service,
      name: 'service',
    },
    {
      icon: (isActive: boolean) => {
        return <LogoutIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />;
      },
      label: 'Logout',
      link: routes.login,
      name: 'logout',
    },
  ];

  return (
    <>
      {is1980 ? (
        <div style={{ overflow: 'auto', height: is1980 ? `calc(100vh - 220px)` : `calc(100vh - 270px)` }} className="scrollbar-cusgray">
          {sideNavContents?.map((items, index) => {
            return (
              <ListItemButton
                onClick={() => {
                  handleListClick(items.link, index);
                }}
                style={{
                  marginTop: '1px',
                }}
                className={`${classes.listItemButton} ${getFirstPath[0] === items.name && classes.listItemButtonActive}`}
              >
                <ListItemIcon
                  sx={{
                    minWidth: { xs: '10px', lg: '30px' },
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '10px',
                    },
                  }}
                >
                  {items.icon(getFirstPath[0] === items.name)}
                </ListItemIcon>
                <ListItemText
                  className={`${classes.listItemText} ${getFirstPath[0] === items.name && classes.listItemTextActive}`}
                  sx={{
                    display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                  }}
                >
                  {items.label}
                </ListItemText>
              </ListItemButton>
            );
          })}
        </div>
      ) : (
        <>
          <div style={{ overflow: 'auto', height: 'calc(100vh - 260px)' }} className="scrollbar-cusgray">
            {sideNavContents?.slice(0, -1)?.map((items, index) => {
              return (
                <ListItemButton
                  onClick={() => {
                    handleListClick(items.link, index);
                  }}
                  style={{
                    marginTop: '1px',
                  }}
                  className={`${classes.listItemButton} ${getFirstPath[0] === items.name && classes.listItemButtonActive}`}
                >
                  <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>{items.icon(getFirstPath[0] === items.name)}</ListItemIcon>
                  <ListItemText
                    className={`${classes.listItemText} ${getFirstPath[0] === items.name && classes.listItemTextActive}`}
                    sx={{
                      display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                    }}
                  >
                    {items.label}
                  </ListItemText>
                </ListItemButton>
              );
            })}
          </div>
          <div>
            {sideNavContents.slice(-1)?.map((items, index) => {
              return (
                <ListItemButton
                  onClick={() => {
                    handleListClick(items.link, index);
                  }}
                  style={{
                    marginTop: '0px',
                    position: 'absolute',
                    bottom: '0px',
                    marginBottom: '64px',
                  }}
                  className={`${classes.listItemButton} ${getFirstPath[0] === items.name && classes.listItemButtonActive}`}
                >
                  <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '30px' } }}>{items.icon(getFirstPath[0] === items.name)}</ListItemIcon>
                  <ListItemText
                    className={`${classes.listItemText} ${getFirstPath[0] === items.name && classes.listItemTextActive}`}
                    sx={{
                      display: { xs: 'none', sm: 'none', md: 'none', lg: 'block' },
                    }}
                  >
                    {items.label}
                  </ListItemText>
                </ListItemButton>
              );
            })}
          </div>
        </>
      )}
    </>
  );
};

export default SideNavTabs;